import type { FC, PropsWithChildren, JSX } from "react";
import { useMemo } from "react";

import { getChildrenRecord } from "../../../../../utils/react";
import { TAG_DISPLAY_NAME } from "../../Tag";

import type { IconProps } from "../../../../Icon";
import type { TagLeftAddons, TagSizes } from "../../types";

interface ILeftAddonMain {
    size?: IconProps["size"];
    tagSize?: TagSizes;
    leftAddon?: TagLeftAddons;
}

interface ILeftAddon {}

const LeftAddon: FC<ILeftAddon> = (props): JSX.Element | null => {
    const { children, size, tagSize, leftAddon } = props as PropsWithChildren<
        ILeftAddon & ILeftAddonMain
    >;

    const { Icon, Counter, Badge } = useMemo(
        () =>
            getChildrenRecord(children, TAG_DISPLAY_NAME, {
                Icon: {
                    props: {
                        size,
                        tagSize,
                    },
                },
                Counter: {
                    props: {
                        size,
                    },
                },
                Badge: {
                    props: {
                        size,
                    },
                },
                Unknown: {
                    skipElement: true,
                },
            }),
        [children, tagSize, size],
    );

    return (() => {
        switch (leftAddon) {
            case "counter":
                return Counter;
            case "icon":
                return Icon;
            case "badge":
                return Badge;
            default:
                return null;
        }
    })();
};

LeftAddon.displayName = "Tag.LeftAddon";

export default LeftAddon;
